import { useContext, useEffect, useState } from 'react';
import { Context } from 'states/Store';
import useStyles from 'style/js-style/components/thirdparties/securityRating/SecurityRatingStyle';
import SecurityRatingGlobalScore from './cyber-maturity/SecurityRatingCyberMaturity';
import SecurityRatingScoresDetail from './scores-detail/SecurityRatingScoresDetail';
import SecurityRatingScoresActions from './actions/SecurityRatingScoresActions';
import { getSecurityRatingScoreHistory } from 'services/edge/SecurityRatingService';
import SecurityRatingActivationForm from '../security-rating-form/SecurityRatingActivationForm';

const SecurityRatingScores = ({ data, onRiskChange = () => { }, thirdPartyId }) => {
  const { classes } = useStyles();
  const [state] = useContext(Context);
  const [securityRatingHistory, setSecurityRatingHistory] = useState();
  const [isUpdateFormDisplayed, setUpdateFormDisplayed] = useState(false);

  useEffect(() => {
    setUpdateFormDisplayed(false);
  }, [data])

  // Fetch Security Rating Scores History
  useEffect(() => {
    async function fetchSecurityRatingScoreHistory() {
      try {
        const result = await getSecurityRatingScoreHistory(
          state.account.id,
          thirdPartyId
        );
        setSecurityRatingHistory(result.content);
      } catch (e) {
        setSecurityRatingHistory();
      }
    }
    if (state.account && thirdPartyId) {
      fetchSecurityRatingScoreHistory();
    }
  }, [state.account, thirdPartyId, data]);

  if (isUpdateFormDisplayed) {
    return <SecurityRatingActivationForm goBack={() => setUpdateFormDisplayed(false)} thirdPartyId={thirdPartyId}/>
  } else {
    return (
      <div className={classes.scoresAvailableWrapper}>

        <SecurityRatingGlobalScore data={data} />

        <div className={classes.scoresDataWrapper}>
          <div className={classes.scoresButtonsWrapper}>
            <SecurityRatingScoresActions
              data={data}
              securityRatingHistory={securityRatingHistory}
              onRiskChange={onRiskChange}
              onFormUpdateClick={() => setUpdateFormDisplayed(true)}
            />
          </div>

          <SecurityRatingScoresDetail data={data} />
        </div>
      </div>
    );
  }
};

export default SecurityRatingScores;